var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Avoid using these api methods directly, from outside hooks/conversation/.
 * Instead use it through a hook. If we really need to use the API directly,
 * then move it into the utils folder
 * */
import { callGet, callPost } from '../../utils/api/chatApiUtil';
import { sortedByDescending } from '../../utils/arrayUtil';
/**
 * Retrieves the list of conversations a user has
 * */
export var fetchMyConversations = function () { return __awaiter(void 0, void 0, void 0, function () {
    var conversations;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, callGet('conversations')];
            case 1:
                conversations = _a.sent();
                return [2 /*return*/, conversations.map(function (conversation) { return (__assign(__assign({}, conversation), { 
                        // Ensure slug is in lowercase
                        slug: conversation.slug.toLowerCase() })); })];
        }
    });
}); };
/**
 * Retrieves the list of messages in current conversation
 * */
export var getConversationMessages = function (slug) { return __awaiter(void 0, void 0, void 0, function () {
    var messages;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, callGet("conversations/" + slug + "/messages")];
            case 1:
                messages = _a.sent();
                return [2 /*return*/, messages.map(function (message) { return (__assign(__assign({}, message), { 
                        // Ensure we always use lower-case slug
                        conversationSlug: message.conversationSlug.toLowerCase() })); })];
        }
    });
}); };
/**
 * Retrieves details about a conversation by its identifier (slug).
 * It also ensures each message is sorted in chronological order,
 * and that slug is returned in lowercase.
 * @param {string} slug Identifier for this conversation
 * @throws {HttpError|TypeError} TypeError may happen on cors failure or some other browser failure
 * */
export var getConversationBySlug = function (slug) { return __awaiter(void 0, void 0, void 0, function () {
    var conversation, messagesSorted;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, callGet("conversations/" + slug)];
            case 1:
                conversation = _a.sent();
                messagesSorted = sortedByDescending(conversation.messages, function (item) { return item.createdOn; });
                return [2 /*return*/, __assign(__assign({}, conversation), { slug: conversation.slug.toLowerCase(), messages: messagesSorted })];
        }
    });
}); };
export var postConversationReply = function (slug, messageText) { return callPost("conversations/" + slug + "/messages", { body: messageText }); };
export var postMarkConversationRead = function (slug) { return callPost("conversations/" + slug + "/mark-seen", {}); };
